module.exports = __webpack_public_path__ + "img/programme2.baefe0d1.png";